import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Login from "../components/Login/Login.jsx";
import Header from "../components/Layout/Header"

const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.user);

  useEffect(() => {
    if(isAuthenticated === true){
      navigate("/home", { replace: true });
    }
  }, [isAuthenticated, navigate])
  
  return (
    <div>
        <Header />
        <Login />
    </div>
  )
}

export default LoginPage;